/**
 * @param value
 * @param words - words for declension ([сеанс, сеанса, сеансів])
 */
export const numeralDeclension = (value: number, words: string[]) => {
  const valueAbs = Math.abs(value) % 100;
  const num = valueAbs % 10;

  if (valueAbs > 10 && valueAbs < 20) return words[2];

  if (num > 1 && num < 5) return words[1];

  if (num === 1) return words[0];

  return words[2];
};
